import $ from 'jquery';
import Swiper from 'swiper';
import 'swiper/css'; 

$(function () {
    // Resize swiper..
    $('.tabbedcards .swiper').css('width', $('.grid-container').outerWidth() + 'px');

    const mobileSlidesPerView = 1.1;
    $('.tabbedcards .swiper').each(function (tc, i) {
        new Swiper(this, {
            direction: 'horizontal',
            loop: false,
            slidesPerView: mobileSlidesPerView,
            spaceBetween: 8,
            breakpoints: {
                799: {
                    slidesPerView: 3,
                    spaceBetween: 24
                }
            }
        }).on('slideChange', function (swiper) {
            if (swiper.params.slidesPerView == mobileSlidesPerView) {
                // Mobile functionality
                const $block = $(swiper.el).parents('.tabbedcards');
                const $orbit = $('.orbit', $block);

                setActiveCard(swiper.activeIndex, $block);
                $orbit.foundation('changeSlide', swiper.previousIndex < swiper.activeIndex, $($('.orbit-slide', $block)[swiper.activeIndex]));
            }
        });
    });
    

    $('.swiper-slide .select-card').on('click', function (evt) {
        evt.preventDefault();
        const $block = $(this).parents('.tabbedcards');
        const properties = getProperties($block, this, false);

        if (properties.ix != properties.newIx) {
            if (properties.swiper.params.slidesPerView != mobileSlidesPerView) {
                // Mobile does this as aprt of the swiper event
                setActiveCard(properties.newIx, $block);
                properties.$orbit.foundation('changeSlide', properties.ix < properties.newIx, $($('.orbit-slide', $block)[properties.newIx]));
            }
            
            if (properties.newIx > properties.ix) {
                // right
                if (properties.newIx - properties.slidesInView >= properties.swiper.snapIndex) {
                    properties.swiper.slideTo(properties.newIx - properties.slidesInView + 1);
                }
            } else {
                // Only move if new item is outside of our current window
                if (properties.newIx < properties.swiper.snapIndex) {
                    properties.swiper.slideTo(properties.newIx);
                }
            }
        }

        setNavButtons(properties.newIx, properties.total, $block);
    });

    $('.tabbedcards .navigation a').on('click', function (evt) {
        evt.preventDefault();
        const $block = $(this).parents('.tabbedcards');
        const properties = getProperties($block, this, true);
        
        if (properties.ix != properties.newIx) {

            if (properties.swiper.params.slidesPerView != mobileSlidesPerView) {
                // Mobile does this as aprt of the swiper event
                properties.$orbit.foundation('changeSlide', properties.ix < properties.newIx, $($('.orbit-slide', $block)[properties.newIx]));
                setActiveCard(properties.newIx, $block);
            }            

            if (properties.newIx > properties.ix) {
                // right
                if (properties.newIx - properties.slidesInView >= properties.swiper.snapIndex) {
                    properties.swiper.slideTo(properties.newIx - properties.slidesInView + 1, 300, false);
                }
            } else {
                // Only move if new item is outside of our current window
                if (properties.newIx < properties.swiper.snapIndex) {
                    properties.swiper.slideTo(properties.newIx, 300, false);
                }
            }
        }

        setNavButtons(properties.newIx, properties.total, $block);
    });

    function setActiveCard(ix, $block) {
        $('.swiper-slide', $block).removeClass('current');
        $($('.swiper-slide', $block)[ix]).addClass('current');
    }

    function setNavButtons(newIx, total, $block) {
        if (newIx == 0) {
            $('.navigation a.left', $block).addClass('disabled');
        } else if (newIx == total - 1) {
            $('.navigation a.right', $block).addClass('disabled');
        } else {
            $('.navigation a', $block).removeClass('disabled');
        }
    }

    function getProperties($block, target, nav) {
        const $target = $(target),
            ix = $('.swiper-slide.current', $block).index(),
            total = $('.swiper-slide', $block).length,
            swiper = $('.swiper', $block)[0].swiper;

        return {
            $orbit: $('.orbit', $block),
            total: total,
            newIx: nav ? $target.hasClass('left') && ix > 0 ? ix - 1 : $target.hasClass('right') && ix < total - 1 ? ix + 1 : ix : $target.parent().index(),
            ix: ix,
            slidesInView: Math.round(swiper.params.slidesPerView),
            swiper: swiper
        }
    }
});
